import React from "react";
import { Navigate } from "react-router-dom";
import { apiClient, baseURL, clearCookie } from "../../api/apiClient";

export const Logout: React.FC = () => {
  SendLogoutApiRequest();
  return <Navigate to="/login" />;
};

const clearUserCredentials = (): boolean => {
  clearCookie("session_expiry");
  // clearCookie("access_token");
  clearCookie("csrf_token");
  clearCookie("sessionid");
  clearCookie("user_data");

  return true;
};

const SendLogoutApiRequest = async () => {
  try {
    clearUserCredentials();
    const response = await apiClient.get(`${baseURL}/auth/cognito-logout/`, {});

    if (response && response.data.logout_url) {
      window.location.href = response.data.logout_url;
      return true;
    }
  } catch (error) {
    return false;
  }
};
